<template>
  <div style="height:50px">
    <el-dropdown
      class="avatar-container"
      trigger="click"
      size="medium"
      @command="mycontent"
    >
      <div class="avatar-wrapper">
        <!-- :content="username" -->
        <el-tooltip
          class="item"
          effect="dark"
          placement="bottom"
          :content="user"
        >
          <el-avatar class="user-avatar" :src="userheadimg"></el-avatar>
        </el-tooltip>
        <span>{{ user }}</span>
        <i class="el-icon-caret-bottom" />
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="personal">账号管理</el-dropdown-item>
        <el-dropdown-item command="home">首页</el-dropdown-item>
        <el-dropdown-item divided command="outlogin">
          <span style="display:block;">退出登录</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "DropDown",
  props: {
    user: {
      type: String,
      default: ""
    },
    userheadimg: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["userinfo"]) //获取用户信息
  },
  data() {
    return {
      username: ""
    };
  },
  created() {},
  methods: {
    mycontent(command) {
      if (command == "personal") {
        this.$emit("showdialongcilck");
      } else if (command == "home") {
        this.$router.push("/");
      } else {
        // 退出登录
        this.webLogout();
      }
    },
    /*
     **  @description 退出登陆
     **  @param {}
     **  @return
     **  @author shipingan
     */
    webLogout() {
      let url = `/dapi/u/webLogout`;
      let params = {
        uid: this.userinfo.uid,
        token: this.userinfo.token
      };
      this.$axios.post(url, this.$qs.stringify(params)).then(res => {
        // 退出成功把userinfo清空--跳转回登陆页面
        if (res.status == 200) {
          this.userinfo.token = "";
          window.location.href = "http://www.110c.net";
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.avatar-container {
  height: 50px;
  margin: 0 40px 0 10px;
  .avatar-wrapper {
    display: flex;
    height: 50px;
    .user-avatar {
      cursor: pointer;
      width: 40px;
      height: 40px;
      margin-top: 5px;
      border-radius: 50%;
    }
    span {
      cursor: pointer;
    }
    .el-icon-caret-bottom {
      cursor: pointer;
      position: absolute;
      right: -20px;
      top: 16px;
      font-size: 16px;
    }
  }
}
</style>
